module.exports = __webpack_public_path__ + "img/l6.32f4c9ea.png";